/**
 * Wording and routing for a protocol that could not be read.
 *
 * The study is kept when a reading fails (it used to be discarded). The user is
 * told plainly what happened and sent to the study's protocol page, which shows
 * the failure and offers the retry. Pure functions, no React, so they can be
 * tested from functions/ (npx vitest run --config vitest.web.config.ts).
 */

/** "The protocol could not be read: <reason>. You can retry." */
export function protocolReadFailureMessage(reason?: string | null): string {
  const trimmed = (reason ?? '').trim().replace(/[.!?\s]+$/, '');
  if (!trimmed) return 'The protocol could not be read. You can retry.';
  return `The protocol could not be read: ${trimmed}. You can retry.`;
}
